import ApprovalHistory from './ApprovalHistory';

export default ApprovalHistory;
